import { Controller } from "@hotwired/stimulus"
import PhotoSwipe from "photoswipe"
import PhotoSwipeLightbox from "photoswipe/lightbox"

export default class extends Controller {
  static values = {
    selector: { type: String, default: "a" },
    showHideAnimationType: { type: String, default: "zoom" },
    zoomAnimationDuration: { type: Number, default: 366 },
    allowPanToNext: { type: Boolean, default: true },
    spacing: { type: Number, default: 0.1 },
    loop: { type: Boolean, default: true },
    pinchToClose: { type: Boolean, default: true },
    closeOnVerticalDrag: { type: Boolean, default: true },
    hideAnimationDuration: { type: Number, default: 333 },
    showAnimationDuration: { type: Number, default: 333 }
  }

  connect() {
    // Map data-sub-html to title attribute for PhotoSwipe caption support
    const items = this.element.querySelectorAll(this.selectorValue)
    items.forEach((item) => {
      if (item.dataset.subHtml && !item.title) {
        item.title = item.dataset.subHtml
      }
    })

    // Initialize PhotoSwipe Lightbox
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.element,
      children: this.selectorValue,
      pswpModule: PhotoSwipe,
      showHideAnimationType: this.showHideAnimationTypeValue,
      zoomAnimationDuration: this.zoomAnimationDurationValue,
      allowPanToNext: this.allowPanToNextValue,
      spacing: this.spacingValue,
      loop: this.loopValue,
      pinchToClose: this.pinchToCloseValue,
      closeOnVerticalDrag: this.closeOnVerticalDragValue,
      hideAnimationDuration: this.hideAnimationDurationValue,
      showAnimationDuration: this.showAnimationDurationValue
    })

    this.lightbox.init()
  }

  disconnect() {
    if (this.lightbox) {
      this.lightbox.destroy()
    }
  }
}

